export default {
  skeletonContainer: {
    width: '100%',
    height: '100%',
    span: {
      display: 'block',
      br: {
        display: 'none'
      }
    }
  },
  skeletonImage: {
    aspectRatio: '1/1',
    mb: 16
  },
  skeletonText: (secondRow: boolean) => ({
    width: secondRow ? '70%' : ['100%', '100%', '70% !important'],
    display: secondRow ? ['block', 'block', 'none !important'] : 'block',
    mb: secondRow ? 0 : '8px'
  })
};